import type { ButtonProps } from '@iheartjane/reefer';
import {
  Banner,
  Button,
  Flex,
  Modal,
  SparkleIcon,
  Typography,
} from '@iheartjane/reefer';

import styles from './MultiThematicRowBanner.module.css';

export const MultiThematicRowBanner = ({
  setLearnMoreModalOpen,
  onAddRow,
  magicRowCount,
}: {
  magicRowCount: number;
  onAddRow: () => void;
  setLearnMoreModalOpen: () => void;
}) => {
  return (
    <Banner
      className={styles['modifiedBanner']}
      mb={32}
      label={
        <div>
          <Flex gap={12} alignItems="center">
            <SparkleIcon size="md" />
            <Typography color="gradient-primary" variant="h2-semibold">
              Add a Recommended row
            </Typography>
          </Flex>
          <Typography color="grays-black" ml={32} pl={4}>
            Personalized. Dynamic. Seamless.
          </Typography>
        </div>
      }
      actions={
        <Flex gap={16}>
          <Button
            className={styles['modifiedTertiaryButton']}
            variant="minimal-inverse"
            label="Learn more"
            onClick={() => setLearnMoreModalOpen()}
          />
          <AddRowButton magicRowCount={magicRowCount} onClick={onAddRow} />
        </Flex>
      }
    />
  );
};

export const LearnMoreRecommendedRowsModal = ({
  closeModal,
  open,
  onAddRow,
  magicRowCount,
}: {
  closeModal: () => void;
  magicRowCount: number;
  onAddRow: () => void;
  open: boolean;
}) => {
  const bodyText =
    'Create a tailored shopping experience with up to 3 AI-powered rows that highlight products your customers are most likely to love. Each row features a unique theme for products tailored to shoppers tastes and preferences.';

  const handleAddRow = () => {
    onAddRow();
    closeModal();
  };

  return (
    <Modal
      variant="dialogue"
      open={open}
      onRequestClose={() => closeModal()}
      className={styles['modal']}
    >
      <Modal.Content>
        <Flex flexDirection="column" gap={24} alignItems="center">
          <Typography variant="h2-semibold" branded>
            Add a Recommended Row
          </Typography>
          <Typography textAlign="center">{bodyText}</Typography>
          <Flex width="100%" gap={16}>
            <Button
              label="Close"
              variant="tertiary"
              onClick={() => closeModal()}
              full
            />
            <AddRowButton
              magicRowCount={magicRowCount}
              onClick={handleAddRow}
              full
            />
          </Flex>
        </Flex>
      </Modal.Content>
    </Modal>
  );
};

export const AddRowButton = ({
  magicRowCount,
  ...props
}: { magicRowCount: number } & ButtonProps) => {
  const isDisabled = magicRowCount >= 3;
  const buttonLabel = magicRowCount === 0 ? 'Add row' : 'Add another row';
  return (
    <Button
      label={buttonLabel}
      disabled={isDisabled}
      variant="gradient-primary"
      {...props}
    />
  );
};
